export default function parseISOToDate(iso: string): Date | undefined {
  if (!iso) return;
  const b = iso.split(/\D+/);
  return new Date(Date.UTC(+b[0], +b[1] - 1, +b[2], +b[3], +b[4], +b[5], +b[6]));
}